'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var LineLogo_module = require('./LineLogo.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const LINE_LOGO_URL = 'https://assets.narvar.com/assets/line.svg';
const LineLogo = () => /*#__PURE__*/React__default["default"].createElement("img", {
  className: LineLogo_module["default"].lineLogo,
  src: LINE_LOGO_URL,
  alt: "line"
});

exports["default"] = LineLogo;
